import { render } from "./EmpresaEstatisticaCard.vue?vue&type=template&id=778eb67f&scoped=true"
import script from "./EmpresaEstatisticaCard.vue?vue&type=script&lang=js"
export * from "./EmpresaEstatisticaCard.vue?vue&type=script&lang=js"

import "./EmpresaEstatisticaCard.vue?vue&type=style&index=0&id=778eb67f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778eb67f"]])

export default __exports__